import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./app/store";
import "./i18n";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { loadPlacesLibrary } from "./helpers/googleMaps/GoogleMapsLoader";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () =>
  root.render(
  <Suspense fallback="loading">
    <GoogleOAuthProvider clientId="286082730980-bg93ovdvtbfdtgtg8r4d1jml8pphs3lm.apps.googleusercontent.com">
      <React.StrictMode>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </React.StrictMode>
    </GoogleOAuthProvider>
  </Suspense>
);

loadPlacesLibrary()
  .catch((error) => {
    console.log(error);
  })
  .finally(renderApp);
